import React from 'react';
import { TipsMapType } from '../index';

export const compareKeyMetricsNegativeTips: TipsMapType = {
  en: 'The share of 1 star and 2 star ratings',
  zh: '一星以及二星评分的占比',
};

export const compareKeyMetricsPositiveTips: TipsMapType = {
  en: 'The share of 5 star rating',
  zh: '五星评分的占比',
};

export const compareKeyMetricsImpressionsTips: TipsMapType = {
  en: (
    <>
      Potential Impressions is the number of times audiences could've viewed
      messages. This includes the total number of followers of all users who
      post text or videos related to this game without deduplication.
      <br />
      If a user posts multiple posts, the number of followers is counted
      multiple times.
    </>
  ),
  zh: (
    <>
      潜在曝光是指用户浏览信息的次数。这包括了所有发布本游戏相关主贴（包括文字贴或视频）的用户粉丝总数（不去重）。
      <br />
      一个发帖人发布多个帖子，粉丝数计算多次。
    </>
  ),
};

export const compareKeyMetricsVideoImpressionsTips: TipsMapType = {
  en: (
    <>
      Potential Impressions is the number of times audiences could've viewed
      messages. This includes the total number of followers of all users who
      have posted content related to this game without deduplication.
      <br />
      If a user posts multiple posts, the number of followers is counted
      multiple times.
    </>
  ),
  zh: (
    <>
      潜在曝光是指用户浏览信息的次数。这包括了所有发布本游戏相关主贴的用户粉丝总数（不去重）
      <br />
      一个发帖人发布多个帖子，粉丝数计算多次。
    </>
  ),
};

export const compareKeyMetricsPostImpressionsTips: TipsMapType = {
  en: (
    <>
      Potential Impressions is the number of times audiences could've viewed
      messages. This includes the total number of followers of all users who
      have posted content related to this game without deduplication.
      <br />
      If a user posts multiple posts, the number of followers is counted
      multiple times.
    </>
  ),
  zh: (
    <>
      潜在曝光是指用户浏览信息的次数。这包括了所有发布本游戏相关主贴的用户粉丝总数（不去重）
      <br />
      一个发帖人发布多个帖子，粉丝数计算多次。
    </>
  ),
};

export const compareKeyMetricsEngagementRateTips: TipsMapType = {
  en: (
    <>
      The number of times users engaged with your content as a percentage of
      impressions. This indicates how engaged people are with your brand.
      <br />
      Engagement Rate = Engagement / Potential Impressions
    </>
  ),
  zh: (
    <>
      互动率是衡量用户与内容互动次数相对于该内容曝光量的比例。该指标展示了用户与游戏品牌的互动程度。
      <br />
      互动率 = 互动量 / 潜在曝光量
    </>
  ),
};

export const compareKeyMetricsPublicationsTips: TipsMapType = {
  en: (
    <>
      The total number of video and text main posts for this game under the
      current filter conditions. Streaming data is not yet included.
    </>
  ),
  zh: <>在当前筛选条件下，本游戏的所有视频和文字贴的总和。暂未包含直播数据。</>,
};

export const compareKeyMetricsVideoPublicationsTips: TipsMapType = {
  en: (
    <>
      The total number of videos for this game under the current filter
      conditions. Streaming data is not yet included.
    </>
  ),
  zh: <>在当前筛选条件下，本游戏的所有视频和文字贴的总和。暂未包含直播数据。</>,
};

export const compareKeyMetricsPostPublicationsTips: TipsMapType = {
  en: (
    <>
      The total number of text main posts for this game under the current filter
      conditions. Streaming data is not yet included.
    </>
  ),
  zh: <>在当前筛选条件下，本游戏的文字主贴的总和。暂未包含直播数据。</>,
};

export const compareKeyMetricsOfficeAccountPublicationsTips: TipsMapType = {
  en: (
    <>
      The total number of video and text main posts for this game's official
      accounts under the current filter conditions. Streaming data is not yet
      included.
    </>
  ),
  zh: (
    <>
      在当前筛选条件下，本游戏官号的所有视频和文字贴的总和。暂未包含直播数据。
    </>
  ),
};

export const compareKeyMetricsViewsTips: TipsMapType = {
  en: (
    <>
      Views represent the total number of video views and actual exposure counts
      for posts for this game. Streaming data is not included.
    </>
  ),
  zh: (
    <>
      观看量是指本游戏相关的所有视频贴观看量及文字贴实际曝光量。未包含直播数据。
    </>
  ),
};


export const compareMarketShareByViewTips: TipsMapType = {
  en: (
    <>
      The proportion of this game's views among the top 100 games within the selected time period.
    </>
  ),
  zh: (
    <>
      本游戏在当前筛选时间段内观看量排名前100的游戏中的占比。
    </>
  ),
};


export const compareKeyMetricsVideoViewsTips: TipsMapType = {
  en: (
    <>
      Views represent the total number of video views for this game. Among them,
      TikTok views count is equal to the number of impressions. Streaming data
      is not included.
    </>
  ),
  zh: (
    <>
      播放量是指本游戏相关的所有视频贴观看量总和。其中Tiktok
      播放量等于曝光量。未包含直播数据。
    </>
  ),
};

export const compareKeyMetricsPostViewsTips: TipsMapType = {
  en: (
    <>
      Views refer to the total number of actual exposure of the posts related to
      this game.
    </>
  ),
  zh: <>观看量是指本游戏发布的所有文字贴实际曝光量的总和。</>,
};

export const compareKeyMetricsOfficeAccountViewsTips: TipsMapType = {
  en: (
    <>
      Views represent the total number of video views and actual exposure counts
      for posts on this game's official accounts. Streaming data is not
      included.
    </>
  ),
  zh: (
    <>
      观看量是指本游戏官号发布的所有视频贴观看量及文字贴实际曝光量总和。未包含直播数据。
    </>
  ),
};

export const compareKeyMetricsEngagementTips: TipsMapType = {
  en: (
    <>
      The total engagement count for all videos, posts, and comments for this
      game, including likes, dislikes, comments, and shares, under the current
      filter conditions. Streaming data is not yet included.
    </>
  ),
  zh: (
    <>
      在当前筛选条件下，统计本游戏所有视频贴、文字贴及评论的总互动量，互动量涵盖点赞、点踩、评论和转发。暂未包含直播数据。
    </>
  ),
};

export const compareKeyMetricsVideoEngagementTips: TipsMapType = {
  en: (
    <>
      The total engagement count for all videos and comments for this game,
      including likes, dislikes, comments, and shares, under the current filter
      conditions. Streaming data is not yet included.
    </>
  ),
  zh: (
    <>
      在当前筛选条件下，统计本游戏所有视频及评论的总互动量，互动量涵盖点赞、点踩、评论和转发。暂未包含直播数据。
    </>
  ),
};

export const compareKeyMetricsPostsEngagementTips: TipsMapType = {
  en: (
    <>
      The total engagement count for all posts, and comments for this game,
      including likes, dislikes, comments, and shares, under the current filter
      conditions. Streaming data is not yet included.
    </>
  ),
  zh: (
    <>
      在当前筛选条件下，统计本游戏所有文字贴及评论的总互动量，互动量涵盖点赞、点踩、评论和转发。暂未包含直播数据。
    </>
  ),
};

export const compareKeyMetricsOfficeAccountEngagementTips: TipsMapType = {
  en: (
    <>
      The total engagement count for all videos, posts, and comments for this
      game's official accounts, including likes, dislikes, comments, and shares,
      under the current filter conditions. Streaming data is not yet included.
    </>
  ),
  zh: (
    <>
      在当前筛选条件下，统计本游戏官号所有视频贴、文字贴及评论的总互动量，互动量涵盖点赞、点踩、评论和转发。暂未包含直播数据。
    </>
  ),
};

export const compareKeyMetricsCreatorTips: TipsMapType = {
  en: (
    <>
      Users who have posted videos or text posts, with duplicates eliminated
      based on channel and username.
    </>
  ),
  zh: (
    <>
      在当前筛选条件下，发布过视频或文字主贴的用户，并依据渠道和用户名进行去重。
    </>
  ),
};

export const compareKeyMetricsVideoCreatorTips: TipsMapType = {
  en: (
    <>
      Users who have posted videos, with duplicates eliminated based on channel
      and username.
    </>
  ),
  zh: <>在当前筛选条件下，发布过视频的用户，并依据渠道和用户名进行去重。</>,
};

export const compareKeyMetricsPostCreatorTips: TipsMapType = {
  en: (
    <>
      Users who have posted text posts, with duplicates eliminated based on
      channel and username.
    </>
  ),
  zh: <>在当前筛选条件下，发布过文字贴的用户，并依据渠道和用户名进行去重。</>,
};
